import { RM01 } from "./RM01";
import { RM03 } from "./RM03";
import { RM04 } from "./RM04";
import { RM05 } from "./RM05";
import { RM06 } from "./RM06";
import { RM07 } from "./RM07";
import { RM08 } from "./RM08";
import { RM09 } from "./RM09";

export const RegionCoverageReport = {
  sections: [
    RM08,
    RM07,
    RM09,
    RM06, 
    RM01, 
    RM05, 
    RM03, 
    RM04
  ],
};
